module.exports = __webpack_public_path__ + "static/gilardi-25e05c479def4794559d0be3bc7fe93d.jpg";